import yup from 'utils/yup';

export const initialCABreakComplianceFormData = {
  restBreakCompliance: '',
  mealBreakCompliance: '',
  mealBreakReason: '',
  restBreakReason: '',
};

export const CABreakComplianceFormValidationSchema = yup.object().shape({
  restBreakCompliance: yup.string().required(),
  mealBreakCompliance: yup.string().required(),
  mealBreakReason: yup.string().when('mealBreakCompliance', {
    is: 'no',
    then: yup.string().min(10).required(),
  }),
  restBreakReason: yup.string().when('restBreakCompliance', {
    is: 'no',
    then: yup.string().min(10).required(),
  }),
});
